import { render, staticRenderFns } from "./threedee.vue?vue&type=template&id=dd1fc40a&scoped=true&"
import script from "./threedee.vue?vue&type=script&lang=js&"
export * from "./threedee.vue?vue&type=script&lang=js&"
import style0 from "./threedee.vue?vue&type=style&index=0&id=dd1fc40a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1fc40a",
  null
  
)

export default component.exports